import { render, staticRenderFns } from "./UserCompetitionWidget.vue?vue&type=template&id=541ef836&scoped=true&"
import script from "./UserCompetitionWidget.vue?vue&type=script&lang=js&"
export * from "./UserCompetitionWidget.vue?vue&type=script&lang=js&"
import style0 from "./UserCompetitionWidget.vue?vue&type=style&index=0&id=541ef836&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541ef836",
  null
  
)

export default component.exports